module.exports = __webpack_public_path__ + "f9d1751235678c297f58dd994ee46989.svg";